import { render, staticRenderFns } from "./ManageExam.vue?vue&type=template&id=e1f1b742&scoped=true"
import script from "./ManageExam.vue?vue&type=script&lang=js"
export * from "./ManageExam.vue?vue&type=script&lang=js"
import style0 from "./ManageExam.vue?vue&type=style&index=0&id=e1f1b742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f1b742",
  null
  
)

export default component.exports